import React, { Component, Fragment} from 'react';
import CSSModules from 'react-css-modules';
import styles from "./styles.module.css";
import Header from "../components/Header/Header";

class AdminPage extends Component {

  render() {

    return (
      <Fragment>
        <Header />
        <div styleName="admin-page">
          <div styleName="label">
            Embed video on your own site using the following code:
          </div>
          <textarea styleName="textarea" readonly="readonly">
            {
  `<iframe
    width="560"
    height="315"
    frameborder="0"
    allowfullscreen
    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    src="${window.location.protocol}//${window.location.host}/${process.env.REACT_APP_STREAM_KEY}/#/embed"
  ></iframe>`
            }
          </textarea>
        </div>
      </Fragment>
    );
  }
}

export default CSSModules(AdminPage, styles, {allowMultiple: true,});
